/*import { lazy } from 'react'
import suspenseComponent from '../../../../util/suspenseComponent'

const StyleSettingsLazy = lazy(() => import('./StyleSettings'))
const StyleSettings = suspenseComponent(StyleSettingsLazy)*/

export * from './StyleSettings'
